import React from "react";
import { Link } from "react-router-dom";
import DetailedUsageTable from "../components/Usage/DetailedUsageTable";
import { Space } from "antd";
import { MoveArrowLeft } from "@vibe/icons";

const DetailedUsageReport = () => {
  return (
    <div className="px-6 pt-8 pb-4 h-screen">
      <Space direction="vertical" className="flex items-start w-full">
        <div>
          <Link to="/">
            <MoveArrowLeft />
          </Link>
        </div>
        <DetailedUsageTable />
      </Space>
    </div>
  );
};

export default DetailedUsageReport;
